import ScoreCardForm from './ScoreCardForm';

export default ScoreCardForm;
